import BackendService from './BackendService';

export default class DealService {
  static getDealers() {
    return BackendService.get('/dealers/all');
  }

  static getDealersLightweight({ addExtraInformation, extraAttributes }) {
    const params = {
      addExtraInformation,
      ...(extraAttributes ? { extraAttributes } : {}),
    };
    return BackendService.get('/dealers/all/lightweight', { params });
  }

  static getDealerStatus(dealerId) {
    return BackendService.get(`/dealers/status/${dealerId}`);
  }

  static getDealer(dealerId) {
    return BackendService.get(`/dealers/${dealerId}`);
  }

  static createDealer(dealer) {
    return BackendService.post('/dealers/new', { body: dealer });
  }

  static updateDealer(dealer, isDiffObject) {
    return BackendService.put(`/dealers/${dealer.id}`, {
      // We use the mergeObjectFields boolean to let backend know if we are sending a diff dealer object instead of a full dealer
      params: {
        mergeObjectFields: isDiffObject,
      },
      body: dealer,
    });
  }

  static validateDealer(dealerId) {
    return BackendService.post(`/dealers/verify/${dealerId}`);
  }

  static runAutomation(dealerId, type = 'papyrus') {
    return BackendService.post('/dealers/verify/createDummyDeal', {
      body: { dealerId, type },
    });
  }

  static cancelValidation(dealerId) {
    return BackendService.delete(`/dealers/verify/${dealerId}`);
  }

  static deleteDealer(dealerId) {
    return BackendService.delete(`/dealers/${dealerId}`);
  }

  static inventoryImport(dealerId) {
    return BackendService.put(`/dealers/import-inventory/${dealerId}`);
  }

  static getYMMT(dealerId) {
    return BackendService.get(`/dealers/ymmt/${dealerId}`);
  }

  static verifyFNICredentials(dealer) {
    return BackendService.post('/dealers/verify/fniCredentials', {
      body: dealer,
    });
  }

  static getPriceRulesRevisions(dealerId) {
    return BackendService.get(`/dealers/priceRuleRevisions/${dealerId}`);
  }

  static getTranslations(dealerId) {
    return BackendService.get(`/dealers/${dealerId}/translations`);
  }

  static updateTranslations(dealerId, translations) {
    return BackendService.put(`/dealers/${dealerId}/translations`, {
      body: translations,
    });
  }

  static setDealerTheme(dealer, theme) {
    return BackendService.put(`/dealers/${dealer.id}`, {
      params: {
        mergeObjectFields: true,
      },
      body: {
        id: dealer.id,
        theme,
      },
    });
  }
}
